<form name="vm.addressForm" class="c-form u-ost-xl" #addressForm="ngForm" novalidate>
    <div class="c-modal c-modal--sm">
        <div mat-dialog-content class="c-modal__dialog">

            <div class="c-modal__header">
                <div class="o-grid">
                    <div class="o-grid__cell u-no-p"></div>
                    <div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
                        <button id="closeAddressModalButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.handleModalClose()">
                            <i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
                            <span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
                        </button>
                    </div>
                </div>
            </div>

            <div class="c-modal__content u-no-pt">
                <div class="o-media c-content u-no-p u-osb-sm">
                    <p class="c-text">{{ 'Modal.Title.Update_Office_Address' | translate }}</p>
                </div>

                <div class="c-form__group u-osb-lg" [ngClass]="{ 'c-form__group--error': vm.submitted && address.invalid }">
                    <label for="{{ 'address-' + vm.uid }}" class="c-form__label c-form__label--light c-form__label--required">
                        {{ 'Modal.Content.Address_Requirements' | translate }}
                    </label>
                    <textarea id="{{ 'address-' + vm.uid }}" name="address" class="c-form__input c-form__input--sm"
                              [(ngModel)]="vm.booking.service.officeAddress" #address="ngModel" maxlength="1024" required rows="4"></textarea>
                    <p class="c-text c-text--sm c-text--gray c-text--right" [ngClass]="{'c-text--s3': vm.submitted && address.invalid }">
                        {{ address?.value?.length || 0 }} / 500
                    </p>
                    <item-form-error *ngIf="vm.submitted && address.invalid"
                                     [fieldName]="'Modal.Content.Address' | translate"
                                     [error]="address?.errors" [noOffset]="true"></item-form-error>
                </div>
            </div>

            <div class="c-modal__footer">
                <div class="o-grid">
                    <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p">
                        <button id="saveAddressButton" type="button" class="c-button c-button--s1 c-button--fit"
                                (click)="vm.handleAddressFormSubmit(addressForm)"
                                [disabled]="vm.submitted && addressForm.invalid">
                            {{ 'Modal.Button.Save' | translate }}
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</form>
